var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeginner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9709 40.5684H42.1606C43.6335 40.5684 44.8274 39.3743 44.8274 37.9015V29.7918C44.8274 28.319 43.6335 27.1251 42.1606 27.1251H28.9784C26.7142 27.1251 24.8785 25.2895 24.8785 23.0252C24.8785 25.2895 23.0429 27.1251 20.7787 27.1251H7.59643C6.12362 27.1251 4.92969 28.319 4.92969 29.7918V37.9015C4.92969 39.3743 6.12362 40.5684 7.59643 40.5684H20.8433",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89453 36.7793V30.8922L12.8747 36.6559C12.9485 36.7624 13.0276 36.7102 13.0276 36.5805L12.9724 30.8812",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0352 30.8812V36.7793",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2555 30.9086H15.793V36.7529H18.2555",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0739 33.8301H15.793",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4293 30.9086H38.9668V36.7529H41.4293",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2478 33.8301H38.9668",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9044 32.2384C32.9044 32.9879 32.2968 33.5956 31.5472 33.5956C31.1755 33.5956 29.834 33.6016 29.834 33.6016V32.2384V30.8812H31.5472C32.2968 30.8812 32.9044 31.4888 32.9044 32.2384Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4341 35.1847C33.4341 36.0615 32.7232 36.7722 31.8465 36.7722C31.4117 36.7722 29.834 36.7793 29.834 36.7793V35.1847V33.5971H31.8465C32.7232 33.5971 33.4341 34.3078 33.4341 35.1847Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7988 30.8812L21.948 36.6908C21.9902 36.8097 22.1588 36.8085 22.1995 36.6891L23.9938 30.8921",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9941 30.8812L25.7839 36.6908C25.8261 36.8097 25.9947 36.8085 26.0353 36.6891L27.1891 30.8921",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8789 23.0244V17.652",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4888 10.2988C29.001 10.2988 27.5741 10.8899 26.522 11.9419C25.4699 12.994 24.8789 14.4209 24.8789 15.9087V19.1484H28.1186C29.6065 19.1484 31.0334 18.5574 32.0855 17.5053C33.1376 16.4533 33.7286 15.0264 33.7286 13.5385V10.2988H30.4888Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5698 17.2827C22.7316 16.4445 21.5948 15.9735 20.4093 15.9735H17.8281V18.5548C17.8281 19.7402 18.299 20.8771 19.1373 21.7153C19.9755 22.5534 21.1123 23.0244 22.2977 23.0244H24.879V20.4432C24.879 19.2577 24.408 18.1209 23.5698 17.2827Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9805 9.73623C24.1918 10.8715 24.8791 12.4577 24.8791 14.1179V19.1484L29.4445 14.583",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8789 23.0244L21.3535 19.499",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginner);
export default __webpack_public_path__ + "static/media/Beginner.3fc1e50920a7c220ac7355f702854637.svg";
export { ForwardRef as ReactComponent };